import { cn } from '@utils/cn';

// Types
export interface Props {
    index: number;
    name: string;
    onClick: (index: number) => void;
    active: boolean;
}

const NavItem = ({ index, name, onClick, active }: Props) => {
    const handleClick = () => onClick(index);

    return (
        <div
            className={cn(
                'flex cursor-pointer items-center rounded-md px-4 py-2 text-center text-xs text-gray-600 shadow-sm outline outline-1 outline-gray-100 transition-all duration-75 hover:bg-gray-100',
                { 'bg-gray-100 shadow-none outline-transparent': active },
            )}
            onClick={handleClick}
        >
            {name}
        </div>
    );
};

export default NavItem;
